const middleware = {}

middleware['track-page-view'] = require('../../../middleware/track-page-view.js')
middleware['track-page-view'] = middleware['track-page-view'].default || middleware['track-page-view']

export default middleware
